export enum Score {
  None = 0,
  Excellent,
  Good,
  Fair,
  NeedsWork,
}

export type KPIScoreLimit = {
  min?: number
  max?: number
  score: Score
}

export type RoutingKPIMetric = {
  score: number
  metric?: number | null
  isLoading: boolean
  isError: boolean
  hasNoData: boolean
  totalRecords?: number
  totalRequests?: number
}
